import React from 'react'
import ErrorFallback from './ErrorFallback'


const PageNotFound = () => (
    <ErrorFallback errorMessage={"Page Not Found"}/>
)

export default PageNotFound
